/**
 * Remembers a parent who has already given us their details (homepage
 * whitepaper form, or the guide page itself) so we never ask twice.
 */

const KEY = "wekit.parent.lead.v1";

export interface ParentLead {
  name: string;
  email: string;
  mobile?: string | null;
  childAge?: string | null;
  at: string;
}

export function saveParentLead(lead: Omit<ParentLead, "at">) {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ ...lead, at: new Date().toISOString() }),
    );
  } catch {
    /* storage may be unavailable — never break the flow */
  }
}

export function readParentLead(): ParentLead | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ParentLead;
    if (!parsed?.email || !parsed?.name) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearParentLead() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
